import { useCallback, useContext } from "react";
import { CardsResultContext } from './cards-context';
import { PaymentMethods } from "../../interfaces/Loan";


export const useCardsResult = () => {
  const { cardsResult, setCardsResult } = useContext(CardsResultContext);

  const createCardsResult = useCallback(
    (newCards: PaymentMethods | undefined): void => {
      setCardsResult(newCards);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cardsResult]
  );

  const deleteCardsResult = useCallback((): void => {
    setCardsResult(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsResult]);

  return {
    cardsResult,
    createCardsResult,
    deleteCardsResult,
  };
};
